import { render, staticRenderFns } from "./openCourse.vue?vue&type=template&id=8ed2ede4&scoped=true&"
import script from "./openCourse.vue?vue&type=script&lang=js&"
export * from "./openCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed2ede4",
  null
  
)

export default component.exports